import { render, staticRenderFns } from "./TrainingUser.vue?vue&type=template&id=060c51d3&scoped=true"
import script from "./TrainingUser.vue?vue&type=script&lang=js"
export * from "./TrainingUser.vue?vue&type=script&lang=js"
import style0 from "./TrainingUser.vue?vue&type=style&index=0&id=060c51d3&prod&lang=less&scoped=true"
import style1 from "./TrainingUser.vue?vue&type=style&index=1&id=060c51d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060c51d3",
  null
  
)

export default component.exports